import ForgotPasswordForm from "../../Forms/ForgotPasswordForm";
import Page from "../../Containers/Page";

function ForgotPassword() {
  return (
    <Page title="Forgotten Password" className="bg-hgBlue-500">
      <ForgotPasswordForm />
    </Page>
  );
}

export default ForgotPassword;
